import React from 'react';
import pp from '../assets/vivek pp.jpg'
const About = () => {
  return (
    <div name='about' className='w-full h-screen  bg-[#0a192f] text-gray-300'>
      <div className='flex flex-col justify-center items-center w-full h-full'>
        
          
        <div className='sm:text-right pb-8 pl-4 mx-auto mb-7'>
            <p className='text-6xl font-bold inline border-b-4 border-pink-600 pr-2'>
              About 
            </p>
           
            <p className='text-6xl font-bold inline border-b-4 border-pink-600'>
            Me
          </p>
          </div>
         
          <div className='max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4'>
            <div >
            <img src={pp} alt="profile" className='rounded-[100%] h-[350px] w-[350px] m-auto'>
            </img>
            </div>
            <div>
              <p className='text-xl font-bold p-4'>
              Hi Everyone, My name is Vivek Kumar and I am from Moradabad,
               Uttar Pradesh (India).
                I have completed Bachelor Of Science Honours in Electronics from Hansraj College,Delhi University.
                 Then I joined full stack development course by Masai School.
                <br/>
                <br/> ★  A very Enthusiastic person who loves to do a job with perfection. I believe that the solution to real-world problems is modern technologies. Always interested in talking about Data Structures and algorithms.

          
              </p>  
            </div>
          </div>
      </div>
    </div>
  );
};

export default About;